import { useMsal } from '@azure/msal-react';
import { FC, PropsWithChildren } from 'react';

import { createAreaHttpRepository } from '@src/main/modules/common/area/infrastructure/AreaHttpRepository';
import { createDashboardHttpRepository } from '@src/main/modules/common/dashboard/infrastructure/DashboardHttpRepository';
import { createLinkHttpRepository } from '@src/main/modules/common/link/infrastructure/LinkHttpReposiroty';
import { createStatisticsHttpRepository } from '@src/main/modules/common/statistics/infrastructure/StatisticsHttpRepository';
import { createUserHttpRepository } from '@src/main/modules/common/user/infrastructure/UserHttpRepository';
import { MsalTokenProvider } from '@src/main/ui/msalConfig';
import { AreaContextProvider } from '@src/main/ui/providers/area/AreaContextProvider';
import { DashboardContextProvider } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { LinkContextProvider } from '@src/main/ui/providers/link/LinkContextProvider';
import { SearchContextProvider } from '@src/main/ui/providers/search/SearchContextProvider';
import { SnackbarContextProvider } from '@src/main/ui/providers/snackbar/SnackbarContextProvider';
import { StatisticsContextProvider } from '@src/main/ui/providers/statistics/StatisticsContextProvider';
import { UserContextProvider } from '@src/main/ui/providers/user/UserContextProvider';

import Snackbar from '@src/main/ui/components/layout/common/Snackbar/Snackbar';

const ProvidersLayout: FC<PropsWithChildren> = ({ children }) => {
  const { instance, accounts } = useMsal();

  return (
    <SnackbarContextProvider>
      <AreaContextProvider
        areaRepository={createAreaHttpRepository(new MsalTokenProvider(instance, accounts))}
      >
        <UserContextProvider
          userRepository={createUserHttpRepository(new MsalTokenProvider(instance, accounts))}
          statisticsRepository={createStatisticsHttpRepository(
            new MsalTokenProvider(instance, accounts),
          )}
        >
          <StatisticsContextProvider
            statisticsRepository={createStatisticsHttpRepository(
              new MsalTokenProvider(instance, accounts),
            )}
          >
            <LinkContextProvider
              linkRepository={createLinkHttpRepository(new MsalTokenProvider(instance, accounts))}
            >
              <DashboardContextProvider
                dashboardRepository={createDashboardHttpRepository(
                  new MsalTokenProvider(instance, accounts),
                )}
              >
                <SearchContextProvider>
                  {children}
                  <Snackbar />
                </SearchContextProvider>
              </DashboardContextProvider>
            </LinkContextProvider>
          </StatisticsContextProvider>
        </UserContextProvider>
      </AreaContextProvider>
    </SnackbarContextProvider>
  );
};

export default ProvidersLayout;
